import { render, staticRenderFns } from "./checkYN.vue?vue&type=template&id=5d04433d&scoped=true&"
import script from "./checkYN.vue?vue&type=script&lang=ts&"
export * from "./checkYN.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d04433d",
  null
  
)

export default component.exports